import React from "react";
import { Col, Offcanvas, Row } from "react-bootstrap";
import { ActionHandlerFunction, AdminUserBase, UserIdentifierBase } from "@preveil-api";
import { AdminUIActionTypes, content_labels, ExportRequest, dayjs, isSameUser } from "src/common";
import { Icon } from "src/components";

type AllProps = {
  export_request: ExportRequest;
  handleAction: ActionHandlerFunction;
  org_users: AdminUserBase[];
};

// Description: Side panel showing the details of the export request
function SidePanelComponent(props: AllProps) {
  const { export_request, handleAction, org_users } = props;
  const _requester = org_users.find((u: AdminUserBase) => isSameUser(u.user_id, export_request.requester));
  const content_label = !!export_request && !!export_request.metadata && 
    [...new Set(
      Object.keys(export_request.metadata)
        .filter((key) => (export_request.metadata as any)[key])
        .map((key) => {
          const _key = key.split("include_")[1];
          return (content_labels.content as any)[_key];
        })
        .filter((value) => !!value)
    )].join(" & "); // Description: get the content label
  const timeframe_label = `${dayjs(export_request?.metadata?.from).format("MM/DD/YYYY")} - ${dayjs(export_request?.metadata?.until).format("MM/DD/YYYY")}`;

  // Description: handle hide modal.
  function handleHideModal() {
    handleAction({ actionType: AdminUIActionTypes.ShowSideNavMenu });
  }

  return <Offcanvas
    className="sidebar narrower-panel user-sidebar"
    show={true}
    placement="end"
    backdrop={false}
    onHide={handleHideModal}>
    <Offcanvas.Header closeButton>
        <Offcanvas.Title className="align-center">
          <Icon className="ficon-download" />
          <h4 className="m-0">Export Details</h4>
        </Offcanvas.Title>
    </Offcanvas.Header>
    <Offcanvas.Body>
      <div className="readonly-details small">
        <p><span>Requester</span>{_requester?.display_name}</p>
        <p><span>Timeframe</span>{timeframe_label}</p>
        <p><span>Content</span>{content_label}</p>
        <p><span>Expires</span>{dayjs(export_request.expiration).format("MMM D, YYYY h:mm A")}</p>
      </div>
      <div className="approvers-panel">
        <Row className="header-row">
          <Col>{`Users: ${export_request?.metadata?.users.length}`}</Col>
        </Row>
        {
          export_request?.metadata && export_request?.metadata?.users.map((user: UserIdentifierBase) => {
            const _user = org_users.find((u) => isSameUser(u.user_id, user.user_id));
            return !!_user && <Row key={user.user_id}>
              <Col md={10}>
                {!!_user.display_name && <p className="semi-bold">{_user.display_name}</p> }
                <p>{user.user_id}</p>
              </Col>
            </Row>;
          })
        }
      </div>
    </Offcanvas.Body>
  </Offcanvas>;
}

export default React.memo(SidePanelComponent);
